var mymap = L.map('mapid').setView([45.7032695, 3.344853599999965], 5);
var popup = L.popup();
var marker = L.marker();

var geocoder = L.Control.geocoder({
    defaultMarkGeocode: false,
    placeholder: 'Rechercher',
    errorMessage: 'Aucun résultat.',
    position: 'bottomright'
}).on('markgeocode', function(e) {
    var bbox = e.geocode.bbox;
    var poly = L.polygon([
        bbox.getSouthEast(),
        bbox.getNorthEast(),
        bbox.getNorthWest(),
        bbox.getSouthWest()
    ]);
    mymap.fitBounds(poly.getBounds());
}).addTo(mymap);

var topoTiles = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
    maxZoom: 19
}).addTo(mymap);

var EsriWorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
});

var baseMaps = {
    "Fond cartographique": topoTiles,
    "Satellite": EsriWorldImagery
};

var overlayMaps = {};

L.control.layers(baseMaps, overlayMaps).addTo(mymap);


function onMapClick(e) {
    infos_loc_supp(e.latlng);
    marker.setLatLng(e.latlng);
    marker.bindPopup('<b><center>Localisation</center></b> (' + e.latlng.lat + ', ' + e.latlng.lng + ')').openPopup();
    marker.addTo(mymap);

    var latitude_final = e.latlng.lat;
    var longitude_final = e.latlng.lng;

    if (document.getElementById("loc_lat") && document.getElementById("loc_long")) {

        document.getElementById("loc_lat").value = latitude_final;
        sexa_coord_lat(document.getElementById("loc_lat"));

        document.getElementById("loc_long").value = longitude_final;
        sexa_coord_long(document.getElementById("loc_long"));
        check_input_vm();
    } //else
    //exit();
}

mymap.on('click', onMapClick);



function infos_loc_supp(coords) {
    var url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + coords.lat + '&lon=' + coords.lng + '&zoom=18&addressdetails=1';
    resetGeolocalisationFields();
    fetch(url)
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            if (!json.hasOwnProperty('error')) {
                var locality;
                document.getElementById('infos_geo_supp').style.display = "block";
                var elt = json.address;

                if (elt.hasOwnProperty('country')) {
                    document.getElementById('loc_country').value = elt.country;
                }
                if (elt.hasOwnProperty('state')) {
                    document.getElementById('loc_reg').value = elt.state;
                }
                if (elt.hasOwnProperty('postcode')) {
                    document.getElementById('loc_dep').value =
                        departements[elt.postcode.slice(0, 2)] ? departements[elt.postcode.slice(0, 2)] : departements[elt.postcode.slice(0, 3)];
                }
                if (elt.hasOwnProperty('postcode')) {
                    document.getElementById('loc_cp').value = elt.postcode;
                }
                if (elt.hasOwnProperty('city') || elt.hasOwnProperty('village') || elt.hasOwnProperty('town')) {
                    locality = elt.city || elt.town || elt.village;
                    document.getElementById('loc_locality').value = locality;
                }

                if (document.getElementById('loc_country').value !== 'France') {
                    document.getElementById('loc_reg').value = '';
                    document.getElementById('loc_dep').value = '';
                    document.getElementById('loc_cp').value = '';
                    document.getElementById('loc_locality').value = '';
                }
            } else {
                resetGeolocalisationFields();
            }
        })
        .catch(function (e) {
            resetGeolocalisationFields();
            console.error(e);
        });

}

function resetGeolocalisationFields() {
    document.getElementById('infos_geo_supp').style.display = "none";
    document.getElementById('loc_country').value = '';
    document.getElementById('loc_reg').value = '';
    document.getElementById('loc_dep').value = '';
    document.getElementById('loc_cp').value = '';
    document.getElementById('loc_locality').value = '';
}



var button_loca_smart = document.getElementById("smart_localisation");

button_loca_smart.addEventListener('click', function() {
    navigator.geolocation.getCurrentPosition(
        gotPosition,
        errorGettingPosition,
        {'enableHighAccuracy':true,'timeout':10000,'maximumAge':0});
});

function gotPosition(pos) {
    var latlng = L.latLng(pos.coords.latitude,  pos.coords.longitude);
    ninja_forms_toggle_login_register(latlng);
    onMapClick({latlng: latlng});
}

function errorGettingPosition(err){
    if(err.code==1){
        alert("Refus de l'utilisateur d'utiliser la géolocalisation.");
    } else if(err.code==2){
        alert("Position non disponible.");
    } else if(err.code==3){
        alert("Délai dépassé.");
    } else {
        alert("Erreur : "+ err.message);
    }
}

var button_find = document.getElementById("find");
button_find.addEventListener('click', function() {
    var lat_find = document.getElementById('loc_lat').value;
    var long_find = document.getElementById('loc_long').value;
    var latlng = L.latLng(lat_find, long_find);
    onMapClick({latlng: latlng});
});

var departements = {
    '1': 'Ain',
    '2': 'Aisne',
    '3': 'Allier',
    '4': 'Alpes-de-Haute-Provence',
    '5': 'Hautes-Alpes',
    '6': 'Alpes-Maritimes',
    '7': 'Ardèche',
    '8': 'Ardennes',
    '9': 'Ariège',
    '10': 'Aube',
    '11': 'Aude',
    '12': 'Aveyron',
    '13': 'Bouches-du-Rhône',
    '14': 'Calvados',
    '15': 'Cantal',
    '16': 'Charente',
    '17': 'Charente-Maritime',
    '18': 'Cher',
    '19': 'Corrèze',
    '2A': 'Corse-du-Sud',
    '2B': 'Haute-Corse',
    '21': 'Côte-d\'Or',
    '22': 'Côtes-d\'Armor',
    '23': 'Creuse',
    '24': 'Dordogne',
    '25': 'Doubs',
    '26': 'Drôme',
    '27': 'Eure',
    '28': 'Eure-et-Loir',
    '29': 'Finistère',
    '30': 'Gard',
    '31': 'Haute-Garonne',
    '32': 'Gers',
    '33': 'Gironde',
    '34': 'Hérault',
    '35': 'Ille-et-Vilaine',
    '36': 'Indre',
    '37': 'Indre-et-Loire',
    '38': 'Isère',
    '39': 'Jura',
    '40': 'Landes',
    '41': 'Loir-et-Cher',
    '42': 'Loire',
    '43': 'Haute-Loire',
    '44': 'Loire-Atlantique',
    '45': 'Loiret',
    '46': 'Lot',
    '47': 'Lot-et-Garonne',
    '48': 'Lozère',
    '49': 'Maine-et-Loire',
    '50': 'Manche',
    '51': 'Marne',
    '52': 'Haute-Marne',
    '53': 'Mayenne',
    '54': 'Meurthe-et-Moselle',
    '55': 'Meuse',
    '56': 'Morbihan',
    '57': 'Moselle',
    '58': 'Nièvre',
    '59': 'Nord',
    '60': 'Oise',
    '61': 'Orne',
    '62': 'Pas-de-Calais',
    '63': 'Puy-de-Dôme',
    '64': 'Pyrénées-Atlantiques',
    '65': 'Hautes-Pyrénées',
    '66': 'Pyrénées-Orientales',
    '67': 'Bas-Rhin',
    '68': 'Haut-Rhin',
    '69': 'Rhône',
    '70': 'Haute-Saône',
    '71': 'Saône-et-Loire',
    '72': 'Sarthe',
    '73': 'Savoie',
    '74': 'Haute-Savoie',
    '75': 'Paris',
    '76': 'Seine-Maritime',
    '77': 'Seine-et-Marne',
    '78': 'Yvelines',
    '79': 'Deux-Sèvres',
    '80': 'Somme',
    '81': 'Tarn',
    '82': 'Tarn-et-Garonne',
    '83': 'Var',
    '84': 'Vaucluse',
    '85': 'Vendée',
    '86': 'Vienne',
    '87': 'Haute-Vienne',
    '88': 'Vosges',
    '89': 'Yonne',
    '90': 'Territoire de Belfort',
    '91': 'Essonne',
    '92': 'Hauts-de-Seine',
    '93': 'Seine-Saint-Denis',
    '94': 'Val-de-Marne',
    '95': 'Val-d\'Oise',
    '971': 'Guadeloupe',
    '972': 'Martinique',
    '973': 'Guyane',
    '974': 'La Réunion',
    '975': 'St-Pierre-et-Miquelon',
    '976': 'Mayotte',
    '986': 'Wallis et Futuna',
    '987': 'Polynésie Française',
    '988': 'Nouvelle Calédonie'
};